// ui/landingPage/samplingEventsTab/slice.js

import { samplingEventsTabUIInitialState } from "./uiLandingPageSamplingEventsTabState";
import { makeSamplingEventsTabUIActions } from "./uiLandingPageSamplingEventsTabActions";

export const createSamplingEventsTabUISlice = (set, get) => ({
  samplingEventsTabUI: samplingEventsTabUIInitialState,
  samplingEventsTabUIActions: Object.freeze(
    makeSamplingEventsTabUIActions(set, get)
  ),
});
